export enum StepperPosition { // Attention, l'ordre est important pour calculer l'inverse
    top,
    left,
    right,
    bottom,
}